import React, { useState } from 'react';
import { notification, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import ProcessoService from '../../services/ProcessoService';
import * as Routes from '../../../scripts/routes';

const BtnClearFilter = ({ tipo }) => {
  const handleClick = () => {
    Turbolinks.visit(Routes.usuario_processos_path({ tipo }));
  };

  return (
    <button className="btn btn-outline-primary" onClick={handleClick}>
      Limpar Filtros
    </button>
  );
};

export default BtnClearFilter;